import { useIntl } from 'react-intl';

import { I18N_LANGUAGES, TLanguageCode, useLanguage } from '@/i18n';

/** Switches the interface language from the dashboard toolbar (same global language as the rest of the app). */
export const DashboardLanguageSelect = () => {
  const intl = useIntl();
  const { currentLanguage, changeLanguage } = useLanguage();

  return (
    <select
      className="select select-sm w-auto min-w-[120px] pr-[34px]"
      aria-label={intl.formatMessage({ id: 'DASHBOARD.LANGUAGE' })}
      value={currentLanguage.code}
      onChange={(event) => {
        const language = I18N_LANGUAGES.find(
          (item) => item.code === (event.target.value as TLanguageCode)
        );
        if (language) {
          changeLanguage(language);
        }
      }}
    >
      {I18N_LANGUAGES.map((language) => (
        <option key={language.code} value={language.code}>
          {language.label}
        </option>
      ))}
    </select>
  );
};
